export const Step3Selectors = {
    COMMON : {
        FORM : '#step3_form',
        SUBMIT_BTN : '#lastStepCartButtonFinal',
        LIGHT_PRELOADER: "#light-preloader"
    }
};export const Step3Selectors = {
    COMMON : {
        FORM : '#step3_form',
        SUBMIT_BTN : '#lastStepCartButtonFinal',
        LIGHT_PRELOADER: "#light-preloader"
    }
};